module.exports = __webpack_public_path__ + "img/cirugia-lasik.02770d92.png";